import { actions } from '../constants/project';
import * as actionTypes from '../../models/action/project';
import { IAction } from '../../models/action/core';
import { IFilterStudent, IStudentItem } from '../../models/components/add-activity-project-content';
import { Log } from 'ng2-logger';

const _logger = Log.create('Project Add Page');
// #region Add Project Action
export function addProjectGetAction(data: actionTypes.IProjectData, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: (value: boolean) => void): actionTypes.IGetAddProject {
    return {
        ProjectData: data,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.ADD_PROJECT_ACTIVITY,
        callback
    };
}

// Add Project Update Get Action
export function updateProjectGetAction(
    dataParams: actionTypes.IProjectParams,
    spinnerId: string,
    spinnerType: 'get' | 'set'
): actionTypes.IUpdateProjectGet {
    return {
        ...dataParams,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.UPDATE_PROJECT_ACTIVITY
    };
}

export function setProjectDataDefault(spinnerId?: string, spinnerType?: 'get' | 'set'): IAction {
    return {
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_PROJECT_DATA_DEFAULT
    };
}

export function updateProjectSetAction(
    ProjectData: actionTypes.IProjectData[] | null,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): actionTypes.ISetAddProject {
    return {
        ProjectData,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_UPDATE_PROJECT_ACTIVITY
    };
}
// #endregion Add Project Action

// #region Delete Project Activity
export function deleteProjectGetAction(data: actionTypes.IDeleteData): actionTypes.IGetDeleteProject {
    return {
        ProjectData: data,
        timestamp: Date.now(),
        type: actions.DELETE_PROJECT_ACTIVITY
    };
}

export function deleteProjectSetAction(deleteProjectStatus: boolean): actionTypes.ISetDeleteProject {
    return {
        deleteProjectStatus,
        timestamp: Date.now(),
        type: actions.DELETE_PROJECT_SET_ACTIVITY
    };
}

//#endregion Delete Project Activity

//#region User Add Modal
export function getAddModalUserList(
    classId: string,
    courseId: string,
    filters?: IFilterStudent,
    reset?: boolean,
    spinnerId?: string,
    spinnerType?: 'get' | 'set',
    disallowedGroupIds?: any,
    selectedGroupId?: string
): actionTypes.IUserAddModalGetAction {
    return {
        ...filters,
        classId,
        courseId,
        reset,
        timestamp: Date.now(),
        type: actions.GET_USER_ADD_MODAL,
        spinnerId,
        spinnerType,
        disallowedGroupIds,
        selectedGroupId
    };
}

export function setAddModalUserList(
    results: IStudentItem[] | null,
    filters: IFilterStudent | null,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): actionTypes.IUserAddModalSetAction {
    return {
        results,
        filters,
        timestamp: Date.now(),
        type: actions.SET_USER_ADD_MODAL,
        spinnerId,
        spinnerType
    };
}

// #endregion User Add Modal

//#region Project Activity Add New Group
export function getProjectAddGroup(
    data: {
        classId: string;
        groupId: string;
        name: string;
        groupType: number;
        description: string;
    },
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): actionTypes.IProjectAddGroupGetAction {
    return {
        ...data,
        timestamp: Date.now(),
        type: actions.GET_PROJECT_ADD_GROUP,
        spinnerId,
        spinnerType
    };
}

export function setProjectAddGroup(
    result: string | null,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): actionTypes.IProjectAddGroupSetAction {
    return {
        result,
        timestamp: Date.now(),
        type: actions.SET_PROJECT_ADD_GROUP,
        spinnerId,
        spinnerType
    };
}

////#endregion Project Activity Add New Group
//#region Project Activity Add New Group
export function getProjectAutoAddGroup(
    data: {
        classId: string;
        size: number;
        count: number;
        groupType: number;
    },
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): actionTypes.IProjectAutoAddGroupGetAction {
    return {
        ...data,
        timestamp: Date.now(),
        type: actions.GET_PROJECT_AUTO_ADD_GROUP,
        spinnerId,
        spinnerType
    };
}

export function setProjectAutoAddGroup(
    result: any | null,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): actionTypes.IProjectAutoAddGroupSetAction {
    return {
        result,
        timestamp: Date.now(),
        type: actions.SET_PROJECT_AUTO_ADD_GROUP,
        spinnerId,
        spinnerType
    };
}

////#endregion Project Activity Add New Group

//#region Project Activity Update Group
export function getProjectUpdateGroup(
    data: {
        classId: string;
        groupId: string;
        name: string;
        groupType: number;
        description: string;
    },
    spinnerId?: string,
    spinnerType?: 'get' | 'set',
    callback?: (value: string) => void
): actionTypes.IProjectUpdateGroupGetAction {
    return {
        ...data,
        timestamp: Date.now(),
        type: actions.GET_PROJECT_UPDATE_GROUP,
        spinnerId,
        spinnerType,
        callback
    };
}

export function setProjectUpdateGroup(
    result: string | null,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): actionTypes.IProjectUpdateGroupSetAction {
    return {
        result,
        timestamp: Date.now(),
        type: actions.SET_PROJECT_UPDATE_GROUP,
        spinnerId,
        spinnerType
    };
}
// #endregion Project Activity Add New Group

//#region Project Activity Tab Fetch All Groups
export function getProjectAllGroups(
    classId: string,
    take: number,
    skip: number,
    searchKey: string,
    getTypes: string,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): actionTypes.IProjectFetchAllGroupsGetAction {
    return {
        classId,
        take,
        skip,
        searchKey,
        getTypes,
        timestamp: Date.now(),
        type: actions.GET_PROJECT_FETCH_ALL_GROUPS,
        spinnerId,
        spinnerType
    };
}

export function setProjectAllGroups(
    result: Array<{ id: string; value: any; type: string }>,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): actionTypes.IProjectFetchAllGroupsSetAction {
    return {
        result,
        timestamp: Date.now(),
        type: actions.SET_PROJECT_FETCH_ALL_GROUPS,
        spinnerId,
        spinnerType
    };
}

// #endregion Project Activity Tab Fetch All Groups

//#region User Add Modal Save Users To a Group
export function getAddModalSaveUsers(
    groupId: string,
    addList: string[],
    spinnerId?: string,
    spinnerType?: 'get' | 'set',
    callback?: (value: boolean) => void
): actionTypes.IAddModalSaveUsersGetAction {
    return {
        groupId,
        addList,
        timestamp: Date.now(),
        type: actions.GET_PROJECT_ADD_USERS_TO_GROUP,
        spinnerId,
        spinnerType,
        callback
    };
}

export function setAddModalSaveUsers(
    result: any,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): actionTypes.IAddModalSaveUsersSetAction {
    return {
        result,
        timestamp: Date.now(),
        type: actions.SET_PROJECT_ADD_USERS_TO_GROUP,
        spinnerId,
        spinnerType
    };
}
// #endregion User Add Modal Save Users To a Group

//#region User Add Modal Save Users To a Group
export function getProjectFetchUsersOfGroup(params: {
    groupId: string;
    take: number;
    skip: number;
    spinnerId?: string;
    spinnerType?: 'get' | 'set';
}): actionTypes.IProjectFetchUsersOfGroupGetAction {
    return {
        ...params,
        timestamp: Date.now(),
        type: actions.GET_PROJECT_FETCH_USERS_OF_GROUP
    };
}

export function setProjectFetchUsersOfGroup(
    results: IStudentItem[] | null,
    filters: IFilterStudent | null,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): actionTypes.IProjectFetchUsersOfGroupSetAction {
    return {
        results,
        filters,
        timestamp: Date.now(),
        type: actions.SET_PROJECT_FETCH_USERS_OF_GROUP,
        spinnerId,
        spinnerType
    };
}
// #endregion User Add Modal Save Users To a Group

export function deleteProjectGroup(groupIds: string[], callback?: (value: boolean) => void): actionTypes.IGetDeleteProjectGroup {
    return {
        groupIds,
        timestamp: Date.now(),
        type: actions.GET_PROJECT_DELETE_GROUP,
        callback
    };
}

export function deleteProjectGroupSetAction(deleteProjectGroupStatus: boolean): actionTypes.ISetDeleteProjectGroup {
    return {
        deleteProjectGroupStatus,
        timestamp: Date.now(),
        type: actions.SET_PROJECT_DELETE_GROUP
    };
}
